.c2{flex-wrap:wrap;}